import { cx } from '@/lib/cx';
import { EM_DASH } from '@/lib/format/number';
import { scoreShape, scoreShapeLabel } from '@/lib/format/score';
import { t } from '@/lib/i18n';
import styles from './ScoreMark.module.css';

interface ScoreMarkProps {
  /** null when the hole has not been played. */
  strokes: number | null;
  par: number;
  size?: 'sm' | 'md' | 'lg';
  onInk?: boolean;
}

/**
 * A single scorecard cell. Renders the stroke count wrapped in the shape that encodes
 * its relation to par, with the relation also stated in the accessible name — a screen
 * reader announces "5, bogey", not just "5".
 */
export function ScoreMark({ strokes, par, size = 'md', onInk = false }: ScoreMarkProps) {
  if (strokes == null) {
    return (
      <span className={cx(styles.mark, styles[size], styles.empty)} aria-label={t('score.notPlayed')}>
        {EM_DASH}
      </span>
    );
  }

  const shape = scoreShape(strokes, par);

  return (
    <span
      className={cx(styles.mark, styles[size], styles[shape], onInk && styles.onInk)}
      aria-label={`${strokes}, ${scoreShapeLabel(shape)}`}
    >
      <span aria-hidden="true">{strokes}</span>
    </span>
  );
}
